import type { ComponentProps } from "react";

export const WarningIcon = ({
  fill = "#F8F9FA",
  stroke = "#F8F9FA",
  ...props
}: ComponentProps<"svg">) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 8V13"
        stroke={stroke}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle cx="12" cy="16" r="0.5" fill={fill} stroke={stroke} />
      <path
        d="M18.6873 20H5.31273C3.80771 20 2.84193 18.4003 3.54289 17.0685L10.2302 4.36269C10.98 2.93801 13.02 2.93802 13.7698 4.36269L20.4571 17.0685C21.1581 18.4003 20.1923 20 18.6873 20Z"
        stroke={stroke}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
